/**
 * Centralized logging utility that controls log output based on environment
 */

type LogLevel = 'error' | 'warn' | 'info' | 'debug';

const isDevelopment = process.env.NODE_ENV === 'development';

class Logger {
  private static instance: Logger;

  private constructor() {}

  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private shouldLog(): boolean {
    return isDevelopment;
  }

  error(message: string, ...args: any[]): void {
    if (this.shouldLog()) {
      console.error(message, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.shouldLog()) {
      console.warn(message, ...args);
    }
  }

  info(message: string, ...args: any[]): void {
    if (this.shouldLog()) {
      console.info(message, ...args);
    }
  }

  debug(message: string, ...args: any[]): void {
    if (this.shouldLog()) {
      console.debug(message, ...args);
    }
  }

  log(level: LogLevel, message: string, ...args: any[]): void {
    switch (level) {
      case 'error':
        this.error(message, ...args);
        break;
      case 'warn':
        this.warn(message, ...args);
        break;
      case 'info':
        this.info(message, ...args);
        break;
      case 'debug':
        this.debug(message, ...args);
        break;
    }
  }
}

export const logger = Logger.getInstance();